import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseServiceV2 } from '@servicesv2';
import { PedidosVieWModel, ConsultaOrdemCompraDuplicadoModel, PedidoDocumentosAnexosViewModel } from 'models/pedidos/PedidosViewModel';

@Injectable()
export class PedidosServiceV2 extends BaseServiceV2 {

  constructor(http: HttpClient) {
    super('Pedidos', http);
  }

  getPedidosCliente(clienteId: number) {
    return this.getAsPromise<PedidosVieWModel[]>(`GetPedidosCliente/${clienteId}`);
  }

  verificaOrdemCompraDuplicado(vm: ConsultaOrdemCompraDuplicadoModel) {
    return this.postAsPromise<ConsultaOrdemCompraDuplicadoModel, PedidosVieWModel>(vm, 'VerificaOrdemCompraDuplicado');
  }

  uploadDocumentosAnexos(pedidoId: number, pedidoItemId: number, files: File[]) {
    if (pedidoId < 1 || pedidoItemId < 1 || files.length < 1) {
      return;
    }

    const form = new FormData();
    files.forEach(file => form.append('documentoAnexo', file));

    return this.postAsPromise<any, any>(form, `uploadPedidoItemDocumentos/${pedidoId}/${pedidoItemId}`)
  }

  buscaPedidoItemDocumentosAnexos(pedidoItemId: number) {
    return this.getAsPromise<PedidoDocumentosAnexosViewModel[]>(`buscaPedidoItemDocumentosAnexos/${pedidoItemId}`);
  }

  downloadPedidoItemDocumentosAnexos(documentoId: number) {
    return this.downloadBlobAsPromise<any>(null, `downloadPedidoItemDocumentoAnexo/${documentoId}`);
  }

  imprimirColetaEstoque(filtro) {
    return this.downloadBlobAsPromise<any>(filtro, 'imprimirColetaEstoque');
  }
}
